import {Model} from "ords/dist/model/model";

export class AssignmentPartFile extends Model {
    isSupportedVideoFormat(){
        if(this.file.extension.toLowerCase() === 'ogv' || this.file.extension.toLowerCase() === 'ogg' ||
            this.file.extension.toLowerCase() === 'mov' || this.file.extension.toLowerCase() === 'mp4' ||
            this.file.extension.toLowerCase() === 'm4v' || this.file.extension.toLowerCase() === 'webm') {
            return true
        }

        return false
    }

    getFileType() {
        switch(this.file.extension){
            case 'jpeg':
            case 'jpg':
            case 'png':
            case 'gif':
                return 'btn-image-type ';

            case 'pdf':
                return 'btn-file-type ';

            case 'doc':
            case 'docx':
                return 'btn-doc-type ';

            case 'ppt':
            case 'pptx':
                return 'btn-doc-type ';

            case 'xls':
            case 'xlx':
                return 'btn-doc-type ';

            case 'cda':
            case 'mp3':
            case 'oga':
                return 'btn-audio-type ';

            case 'mov':
            case 'mpeg':
            case 'mkv':
            case 'ogv':
            case 'webm':
            case '3gp':
                return 'btn-video-type ';

            default:
                return 'btn-file-type ';
        }
    }


}

export const AssignmentPartFileModelConfig = {
    name: 'assignmentPartFile',
    model: AssignmentPartFile
}
